import { TrackingParams } from '@libs/analytics';

export function storePdpFindingMethod() {
    window.sessionStorage.setItem('pdpFindingMethod', TrackingParams.SEARCH_REFERER);
}
